import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TeroService {
  private baseUrl = '/api/tero';

  constructor(private http: HttpClient) {}

  getProductSkus(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/productSkus`);
  }

  getAllProductSkus(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/allProductSkus`);
  }
}
